// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3nfG6","info":"PatientInfo_info__1fgKF"};